import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=7c0bf09e&"
import script from "./profile.ts?vue&type=script&lang=ts&"
export * from "./profile.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports